import { makeStyles } from "@material-ui/core";

export default makeStyles(
  (theme) => ({
    row: {
      display: "flex",
      flexDirection: "column",
      marginTop: "10px",
      textAlign: "left",
      [theme.breakpoints.up("mobile")]: {
        flexDirection: "row",
        justifyContent: "space-between",
      },
    },
    link: {
      textDecoration: "underline",
      textAlign: "center",
      marginTop: 24,
      [theme.breakpoints.up("mobile")]: {
        marginTop: 0,
      },
    },
    text: {
      textAlign: "left",
    },
    captionText: {
      marginTop: 60,
      "& a": {
        "&:hover": {
          "@media (hover: hover)": {
            textDecoration: "underline",
          },
        },
      },
    },
    button: {
      marginTop: 24,
    },
    billingInfo: {
      "& a": {
        "&:hover": {
          "@media (hover: hover)": {
            textDecoration: "underline",
          },
        },
      },
      [theme.breakpoints.up("mobile")]: {
        textAlign: "left",
        maxWidth: "330px",
      },
    },
    placeholder: {
      margin: [10, "auto"],
    },
  }),
  { name: "SubscriptionDetails" },
);
